import { render, staticRenderFns } from "./contentElementExpertAdvice.vue?vue&type=template&id=66e2039e&scoped=true"
import script from "./contentElementExpertAdvice.vue?vue&type=script&lang=js"
export * from "./contentElementExpertAdvice.vue?vue&type=script&lang=js"
import style0 from "./contentElementExpertAdvice.vue?vue&type=style&index=0&id=66e2039e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e2039e",
  null
  
)

export default component.exports